import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';

const PrivateRoute: React.FC = () => {
    const { state } = useAuth();

    if (state.isLoading) {
        // You can return a loader here
        return <div>Loading...</div>;
    }

    return state.isAuthenticated ? <Outlet /> : <Navigate to="/login" />;
};

export default PrivateRoute;
